import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ConfirmActionDialogComponent } from '../confirm-action-dialog/confirm-action-dialog.component';

import { GooglePhotoService, SharedUtilsService } from '@app/services';
import { Job, User } from '@app/models';

@Component({
    selector: 'app-images-viewer-dialog',
    templateUrl: './images-viewer-dialog.component.html',
    styleUrls: ['./images-viewer-dialog.component.scss'],
    standalone: false
})
export class ImagesViewerDialogComponent implements OnInit {
  @Input() titleName: string;
  @Input() imagesPassedIn: any;

  isHotMarket: boolean = null;
  currentUser: User = null;
  currentJob: Job = null;

  constructor(
    public dialogRef: MatDialogRef<ImagesViewerDialogComponent>,
    private confirmActionDialog: MatDialog,
    private _googlePhotoService: GooglePhotoService,
    private _sharedUtilsService: SharedUtilsService
  ) { }

  ngOnInit():void {}


  async confirmDeleteItem(_photo) {
    const dialogRef = this.confirmActionDialog.open(ConfirmActionDialogComponent, {});
    const instance = dialogRef.componentInstance;
    instance.title = 'Confirm Deletion';
    instance.textToDisplay = 'Are you sure you want to delete the following:';

    instance.items = [{_id: _photo._id, name: _photo.name}];

    instance.buttonsInfo = {
      confirmText: 'Delete',
      confirmBtnColor: 'warn',
      denyText: 'Cancel',
      denyBtnColor: ''
    };

    const confirmationResult = await dialogRef.afterClosed().toPromise();

    if (confirmationResult === true) {
      this.deletePhoto(_photo);
    }
  }


  async deletePhoto(_img) {
    // console.log('Is hot market: ', this.isHotMarket);
    // console.log('Image to delete: ', _img);

    if (this.isHotMarket) {
      // remove image from hot market
      const deletedPhoto = await this._googlePhotoService.delete(_img).toPromise();

      if (!deletedPhoto || deletedPhoto === undefined || deletedPhoto['error']) {
        this._sharedUtilsService.showEduNotificationWithOptions("There was an issue deleting this photo. " + deletedPhoto['error'], 3000, "danger");
      } else {
        this._sharedUtilsService.showNotification("Photo deleted successfully.");
      }
    } else {
      // remove image from location info
      const locationInfo = this.currentJob.locationInfo;
      const photoToRemoveIndex = locationInfo.photos.findIndex(_p => _p._id === _img._id);

      if (photoToRemoveIndex !== -1) {
        const photoToRemove = locationInfo.photos[photoToRemoveIndex];
        this.currentJob.locationInfo.photos.splice(photoToRemoveIndex, 1);
        await this._googlePhotoService.delete(photoToRemove).toPromise();
      }
    }
  }


  closeDialog() {
    return this.dialogRef.close(null);
  }
}